import type React from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { NumberOfRatings } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsRatingFilter/components/NumberOfRatings/NumberOfRatings";
import { Score } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsRatingFilter/components/Score/Score";
import { StyledRatingFilterContainer } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsRatingFilter/styles";
import type FindAppsRatingFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/RatingFilter";

export const AppsRatingFilter: React.FC<IFilterViewBaseProps<FindAppsRatingFilter>> = ({
    filter,
    value,
    onFilterUpdate,
}) => {
    return (
        <StyledRatingFilterContainer>
            <Score
                filter={filter}
                onFilterUpdate={onFilterUpdate}
                value={value}
            />
            <NumberOfRatings
                filter={filter}
                onFilterUpdate={onFilterUpdate}
                value={value}
            />
        </StyledRatingFilterContainer>
    );
};
